export default __webpack_public_path__ + "static/media/awaaz.9ad6283a.webp";